export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.076 15.684">
    <path
      id="check-mark"
      className="cls-1"
      d="M-4909.864,1833.554l6.1,6.1,13.563-13.563"
      transform="translate(4910.571 -1825.382)"
    />
  </svg>
);
